module.exports = __webpack_public_path__ + "img/1970East-076_WEB-min.1a009d97.jpg";